import { render, staticRenderFns } from "./PrizeDetails.vue?vue&type=template&id=6579e96b&scoped=true&"
import script from "./PrizeDetails.vue?vue&type=script&lang=js&"
export * from "./PrizeDetails.vue?vue&type=script&lang=js&"
import style0 from "./PrizeDetails.vue?vue&type=style&index=0&id=6579e96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579e96b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6579e96b')) {
      api.createRecord('6579e96b', component.options)
    } else {
      api.reload('6579e96b', component.options)
    }
    module.hot.accept("./PrizeDetails.vue?vue&type=template&id=6579e96b&scoped=true&", function () {
      api.rerender('6579e96b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/PrizeDetails.vue"
export default component.exports